package com.wintermar.inspection.feature.presentation.inspection.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.answer
import org.jetbrains.compose.resources.stringResource

@Composable
fun AnswerChooseView(
    answerType: InspectionAnswerType,
    answerOptionId: String,
    templateOptions: List<TemplateOptionModel>,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(dimension.spacing.space2)
    ) {
        TextBodySmall(text = stringResource(Res.string.answer), color = { it.subtle })
        AnswerBadge(
            answerType,
            answerOptionId,
            templateOptions
        )
    }
}
